module.exports = __webpack_public_path__ + "img/iaishop.a3075271.png";